<template>
  <c-missing>Page not found.</c-missing>
</template>

<script>
export default {
  name: 'not-found'
};
</script>

<style lang="scss" scoped>
</style>
